import React, { useCallback, useMemo, useRef, } from 'react'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaDownload } from 'react-icons/fa6'
import '../../LMS_CSS/LMS_DataTable.css'

export default function DataTables(props) {

    const gridRef = useRef()

    const defaultColDef = useMemo(() => ({
        flex: 1,
        resizable: true,
    }), [])

    const paginationNumberFormatter = useCallback((params) => {
        return (
            params.value.toLocaleString()
        )
    }, []);

    const onFirstDataRendered = useCallback((params) => {
        // gridRef.current.api.sizeColumnsToFit();

        const nodesToSelect = [];
        gridRef.current.api.forEachNode((node) => {

            if (props.field == 'employee') {
                props.preSelected && props.preSelected.some(function (ele) {
                    // return ele.vemp_code == row.vemp_code
                    if (node.data && node.data.vemp_code === ele.vemp_code) {
                        nodesToSelect.push(node);
                    }
                })
            }

            if (props.field == 'question') {
                props.preSelected && props.preSelected.some(function (ele) {
                    // return ele.vemp_code == row.vemp_code
                    if (node.data && node.data.id === ele.question_id) {
                        nodesToSelect.push(node);
                    }
                })
            }

            if (props.field == 'course') {
                props.preSelected && props.preSelected.some(function (ele) {
                    // return ele.vemp_code == row.vemp_code
                    if (node.data && node.data.id === ele.course_id) {
                        nodesToSelect.push(node);
                    }
                })
            }

            if (props.field == 'edit_employee') {
                props.preSelected && props.preSelected.some(function (ele) {
                    // return ele.vemp_code == row.vemp_code
                    if (node.data && node.data.vemp_code === ele.vemp_code) {
                        nodesToSelect.push(node);
                    }
                })
            }
        });
        gridRef.current.api.setNodesSelected({
            nodes: nodesToSelect,
            newValue: true,
        });
    }, []);

    const onGridSizeChanged = useCallback((params) => {
        // gridRef.current.api.sizeColumnsToFit();
    }, []);

    const onPageSizeChanged = useCallback(() => {
        var value = document.getElementById(props?.id ? props?.id : 'page-size').value;
        gridRef.current.api.paginationSetPageSize(Number(value));
    }, []);

    const onBtnExport = useCallback(() => {
        // var params = {
        //     columnKeys: ['vdepartment_name', 'vdept_manager_name', 'icount_employee', 'cstatus']
        // };
        gridRef.current.api.exportDataAsCsv();
    }, []);

    const onSelectionChanged = useCallback((params) => {

        const selectedData = gridRef.current.api.getSelectedRows();
        // console.log('Selection updated', selectedData);
        // console.log(props.field)
        // props.value(props.field, props.filterData ? selectedData[0].id : selectedData)

        if (props && props.addCourseModal) {
            // console.log("1", selectedData)
            props.value(`content[${document.getElementById('upinput').value}].file`, selectedData && selectedData[0] && selectedData[0].file_path)
        } else if (props && props.addGroupCheck) {
            // console.log("2", selectedData)
            props.value(props.field, selectedData)
        } else if (props && props.addQuizCheck) {
            // console.log("3", selectedData)
            props.value(props.field, selectedData)
        } else if (props && props.addLearningTrack) {
            //  console.log("4", selectedData)
            props.value(props.field, selectedData)
        } else if (props && props.addTrainingCheck) {
            //  console.log("5", selectedData)
            props.value(props.field, selectedData)
        } else if (props && props.editTrainingCheck) {
            //  console.log("6", selectedData)
            props.value(props.field, selectedData)
        } else if (props && props.addAttendanceCheck) {
            //  console.log("7", selectedData)
            props.value(props.field, selectedData)
        }

    }, []);

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <div className="example-header d-flex align-items-baseline">
                    <label htmlFor="" className="form-label form_label">Size</label>
                    <select className="form-select form_input_data ms-2" onChange={onPageSizeChanged} id={props?.id ? props?.id : "page-size"} style={{ width: '12vh' }}>
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                    </select>
                </div>
                <FaDownload size={25} onClick={onBtnExport} style={{ cursor: 'pointer', color: '#2262C6' }} />
            </div>
            <div className="ag-theme-alpine mt-2" style={{ height: props && props.height ? props.height : '65vh', width: '100%', boxShadow: "0px 0px 8px 1px #d0d0d0", borderRadius: '8px' }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData ? props.rowData : ''}
                    columnDefs={props.columnDefs ? props.columnDefs : ''}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={10}
                    paginationNumberFormatter={paginationNumberFormatter}
                    onFirstDataRendered={onFirstDataRendered}
                    onGridSizeChanged={onGridSizeChanged}
                    rowHeight={props.rowHeight ? props.rowHeight : ''}

                    rowSelection={props.check ? props.check : ''}
                    suppressRowClickSelection={props.selection ? true : ''}
                    onSelectionChanged={props.selection ? onSelectionChanged : ''}
                />
            </div >
        </>
    )
}
